import { ApiService } from '../../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigGroupService {
  constructor(private apiService: ApiService) {
  }

  GetGroups() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBGroups')
      .map(
      data => {
        return data;
      }
      );
  }

  GetFields() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBFields')
      .map(
      data => {
        return data;
      }
      );
  }

  GetSections() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBSections')
      .map(
      data => {
        return data;
      }
      );
  }

  AddGroup(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/add/group', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "e";
      }
      );
  }

  EditGroup(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/edit/group', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "error";
      }
      );
  }

  AddField(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/add/field', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "error";
      }
      );
  }

   GetGroupById(Id) {
    return this.apiService.get('/api/mvp/dfb/get/group/Id/?groupId='+Id)
      .map(
      data => {
        return data;
      }
      );
  }
}





// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configur_group/group.service.ts